// extracted by mini-css-extract-plugin
module.exports = {"solution_boxText":"Solution_solution_boxText__A8iOA","solution_logo":"Solution_solution_logo__ZOnse","solution_boxSlider":"Solution_solution_boxSlider__1An-Y"};